import { render } from "./TreesBanner.vue?vue&type=template&id=10dbc0a1"
import script from "./TreesBanner.vue?vue&type=script&lang=js"
export * from "./TreesBanner.vue?vue&type=script&lang=js"

import "./TreesBanner.vue?vue&type=style&index=0&id=10dbc0a1&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\compro.rimba.vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__